import { render, staticRenderFns } from "./UpsertWidgetSetting.vue?vue&type=template&id=2cc36283&"
import script from "./UpsertWidgetSetting.vue?vue&type=script&lang=ts&"
export * from "./UpsertWidgetSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports